import React, { useState } from 'react';
import { SpacingStack } from '@components/SpacingStack';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Text } from '@components/typography';
import ReactHtmlParser from 'react-html-parser';
import { getFormattedDate } from '@utils/formatDate';
import { StyledShowMoreButton } from './AccouncementsSection.styles';
interface AnnouncementsNodeType
  extends Readonly<{
    title: string;
    subtitle: string;
    link: string;
    date: string;
  }> {}

interface AccouncementsProps {
  announcementsNodes: ReadonlyArray<AnnouncementsNodeType>;
}

export const AccouncementsSection: React.FC<AccouncementsProps> = ({ announcementsNodes }) => {
  const [numItemsShown, setNumItemsShown] = useState(4);

  const showMore = () => {
    const nextNumItemsToShow = numItemsShown + 3;
    if (numItemsShown === announcementsNodes.length) {
      setNumItemsShown(4);
    } else if (nextNumItemsToShow < announcementsNodes.length) {
      setNumItemsShown(nextNumItemsToShow);
    } else {
      setNumItemsShown(announcementsNodes.length);
    }
  };

  return (
    <Box backgroundColor="yellow1" paddingY={[10, 10, 12]} paddingX={[5, 5, 11]} id="announcements">
      <Columns>
        <Columns.Column width="half">
          <Text tagName="h2" variant="hed72Hero" color="red6">
            This just in.
          </Text>
        </Columns.Column>
        <Columns.Column width="half">
          <SpacingStack spacing="80px">
            {announcementsNodes.slice(0, numItemsShown).map((item, index) => {
              return (
                <SpacingStack key={index} spacing={4}>
                  <Text variant="calloutHed32" color="red6" tagName="h2">
                    {item.title}
                  </Text>
                  <Text variant="featureCopy17" color="red6" tagName="span">
                    {item.date}
                  </Text>
                  <Text variant="featureCopy17" color="red6" tagName="h3">
                    {ReactHtmlParser(item.subtitle)}
                  </Text>
                  <a href={item.link} target="__blank" aria-label={item.link}>
                    <Text tagName="span" color="purple4" variant="featureCopy17">
                      Read more
                    </Text>
                  </a>
                </SpacingStack>
              );
            })}
          </SpacingStack>
        </Columns.Column>
      </Columns>
      <StyledShowMoreButton onClick={showMore} aria-label="View more news">
        <Text tagName={'p'} variant={'featureCopy17'}>
          {numItemsShown === announcementsNodes.length ? 'View less' : 'View more'}
        </Text>
      </StyledShowMoreButton>
    </Box>
  );
};
